var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"owc-subnavigation-cta-buttons"},[(_vm.isIconOnly && _vm.ctaIcon)?[_c('a',{class:[
        'wb-button',
        'wb-button--primary',
        'wb-button--medium',
        'wb-button--icon-only',
        'owc-subnavigation__cta-button-primary',
        {
          'owc-subnavigation__cta-button-primary--visible': _vm.isConfigurationButtonVisible,
          'owc-subnavigation__cta-button-primary--active': _vm.isCtaButtonsTransitioned,
        },
      ],attrs:{"href":_vm.ctaIcon.url,"target":"_self","aria-label":_vm.ctaIcon.label},on:{"transitionend":function($event){$event.stopPropagation();}}},[_c('wb-icon',{staticClass:"wb-button__icon",attrs:{"aria-hidden":"true","name":_vm.ctaIcon.icon}})],1)]:_vm._l((_vm.ctas),function(cta){return _c('a',{directives:[{name:"show",rawName:"v-show",value:(!!cta.label),expression:"!!cta.label"}],key:cta.label,staticClass:"owc-subnavigation-cta-buttons__button wb-button",class:[
        {
          'wb-button--theme-dark': _vm.isDarkMode,
          'wb-button--large': _vm.mobile,
          'wb-button--small': !_vm.mobile,
        },
        _vm.getCtaButtonClasses(cta),
      ],attrs:{"target":cta.target,"href":cta.url},on:{"click":function($event){return _vm.$emit('closeSecondLevel')}}},[_vm._v(" "+_vm._s(cta.label)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }